import React, {Component} from "react";
import DataTable from 'react-data-table-component';
import {Button, Col, Container, Row} from "react-bootstrap";
import "./SecondMeasureResult.css";
import {Line} from "react-chartjs-2";
import Form from "react-bootstrap/Form";
import axios from "axios";

const options = {
    scales: {
        yAxes: [
            {
                ticks: {
                    beginAtZero: true,
                },
            },
        ],
    }
};

const columns = [
    {
        name: 'Type',
        selector: 'impactType',
        sortable: true,
        wrap: true
    },
    {
        name: 'id',
        selector: 'id',
        sortable: true,
        maxWidth: '5px'
    },
    {
        name: 'Impact',
        selector: 'impact',
        sortable: false,
        wrap: true,
        grow: 2

    },
    {
        name: 'Description',
        selector: 'description',
        sortable: false,
        grow: 8
    },
    {
        name: 'Measurement Unit',
        selector: 'measurementUnit',
        sortable: false,
        grow: 2
    }
];

for (let i = 2020; i <= 2050; i++) {
    columns.push({
        name: '' + i,
        selector: '' + i,
        sortable: true
    });
}

class SecondMeasureResult extends Component {

    componentDidMount() {
        this.retrieveInterventions();
        this.retrieveSecondInterventions();
    }

    state = {
        interventions: [],
        secondInterventions: [],
        impact: '',
        policyIntervention: '',
        secondPolicyIntervention: '',
        policyYear: '2021',
        data: null,
        userCase: this.props.useCase,
        subUseCase: this.props.subUseCase,
        secondUseCase: this.props.secondUseCase,
        secondSubUseCase: this.props.secondSubUseCase,
        firstMeasure: {
            withoutPolicyData: this.props.data['RESULTS_1']['WITHOUT_POLICY_INTERVENTION'],
            withPolicyDataCase1: this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE1'],
            withPolicyDataCase2: this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE2'],
            withPolicyDataCase3: this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE3'],
            withPolicyDataCase4: this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE4'],
            withPolicyDataCase5: this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE5'],
            withPolicyDataCase6: this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE6'],
            withPolicyDataCase7: this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE7'],
            withPolicyDataCase8: this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE8'],
            withPolicyDataCase9: this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE9'],
            withPolicyDataCase10: this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE10'],
            withPolicyDataCase11: this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE11'],
            withPolicyDataCase12: this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE12'],
            policyParams: this.props.data['RESULTS_1']['POLICY_PARAMS']
        },
        secondMeasure: {
            withoutPolicyData: this.props.data['RESULTS_2']['WITHOUT_POLICY_INTERVENTION'],
            withPolicyDataCase1: this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE1'],
            withPolicyDataCase2: this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE2'],
            withPolicyDataCase3: this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE3'],
            withPolicyDataCase4: this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE4'],
            withPolicyDataCase5: this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE5'],
            withPolicyDataCase6: this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE6'],
            withPolicyDataCase7: this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE7'],
            withPolicyDataCase8: this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE8'],
            withPolicyDataCase9: this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE9'],
            withPolicyDataCase10: this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE10'],
            withPolicyDataCase11: this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE11'],
            withPolicyDataCase12: this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE12'],
            policyParams: this.props.data['RESULTS_2']['POLICY_PARAMS']
        },

        withoutPolicyData: this.calculateMultipleMeasures(this.props.data['RESULTS_1']['WITHOUT_POLICY_INTERVENTION'], this.props.data['RESULTS_2']['WITHOUT_POLICY_INTERVENTION']),
        withPolicyDataCase1: this.calculateMultipleMeasures(this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE1'], this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE1']),
        withPolicyDataCase2: this.calculateMultipleMeasures(this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE2'], this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE2']),
        withPolicyDataCase3: this.calculateMultipleMeasures(this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE3'], this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE3']),
        withPolicyDataCase4: this.calculateMultipleMeasures(this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE4'], this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE4']),
        withPolicyDataCase5: this.calculateMultipleMeasures(this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE5'], this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE5']),
        withPolicyDataCase6: this.calculateMultipleMeasures(this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE6'], this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE6']),
        withPolicyDataCase7: this.calculateMultipleMeasures(this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE7'], this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE7']),
        withPolicyDataCase8: this.calculateMultipleMeasures(this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE8'], this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE8']),
        withPolicyDataCase9: this.calculateMultipleMeasures(this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE9'], this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE9']),
        withPolicyDataCase10: this.calculateMultipleMeasures(this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE10'], this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE10']),
        withPolicyDataCase11: this.calculateMultipleMeasures(this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE11'], this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE11']),
        withPolicyDataCase12: this.calculateMultipleMeasures(this.props.data['RESULTS_1']['WITH_POLICY_INTERVENTION_CASE12'], this.props.data['RESULTS_2']['WITH_POLICY_INTERVENTION_CASE12'])
    };

    calculateMultipleMeasures(firstMeasure, secondMeasure) {
        let totalResults = [];

        if (!firstMeasure && !secondMeasure) {
            return null;
        } else if (firstMeasure && !secondMeasure) {
            firstMeasure.forEach(function (first) {
                totalResults.push({
                    impact: first.impact,
                    valuesMap: first.valuesMap
                })
            });
        } else if (!firstMeasure && secondMeasure) {
            secondMeasure.forEach(function (second) {
                totalResults.push({
                    impact: second.impact,
                    valuesMap: second.valuesMap
                })
            });
        } else {
            var that = this;
            firstMeasure.forEach(function (first) {
                let impact = first.impact;
                var newValuesMap = {};
                secondMeasure.forEach((second => {
                    if (first.impact.id === second.impact.id) {
                        for (var key of Object.keys(first.valuesMap)) {
                            let firstVal = first.valuesMap[key];
                            let secondVal = second.valuesMap[key];
                            newValuesMap[key] = that.calculateFormula(firstVal, secondVal);
                        }
                    }
                }));
                totalResults.push({
                    impact: impact,
                    valuesMap: newValuesMap
                })
            });
        }

        return totalResults;
    }

    calculateFormula(firstValue, secondValue) {
        let value;
        if ((this.props.subUseCase.id === 'ON_DEMAND_SHUTTLE_BUS_SERVICE' && this.props.secondSubUseCase.id === 'AUTOMATED_RIDE_SHARING') ||
            (this.props.subUseCase.id === 'AUTOMATED_RIDE_SHARING' && this.props.secondSubUseCase.id === 'ON_DEMAND_SHUTTLE_BUS_SERVICE')) {
            let minValue = Math.min(firstValue, secondValue);
            value = Math.pow((firstValue * secondValue), minValue);
        } else if ((this.props.subUseCase.id === 'SHUTTLE_BUS_SERVICE' && this.props.secondSubUseCase.id === 'AUTOMATED_RIDE_SHARING') ||
            (this.props.subUseCase.id === 'AUTOMATED_RIDE_SHARING' && this.props.secondSubUseCase.id === 'SHUTTLE_BUS_SERVICE')) {
            value = Math.min(firstValue, secondValue);
        } else if ((this.props.subUseCase.id === 'SHUTTLE_LARGE_SCALE' && this.props.secondSubUseCase.id === 'AUTOMATED_RIDE_SHARING') ||
            (this.props.subUseCase.id === 'AUTOMATED_RIDE_SHARING' && this.props.secondSubUseCase.id === 'SHUTTLE_LARGE_SCALE')) {
            value = Math.min(firstValue, secondValue);
        } else if ((this.props.subUseCase.id === 'CITY_TOLLS' && this.props.secondSubUseCase.id === 'AUTOMATED_RIDE_SHARING') ||
            (this.props.subUseCase.id === 'AUTOMATED_RIDE_SHARING' && this.props.secondSubUseCase.id === 'CITY_TOLLS')) {
            value = firstValue * secondValue;
        } else if ((this.props.subUseCase.id === 'AUTOMATED_CONSOLIDATION' && this.props.secondSubUseCase.id === 'AUTOMATED_DELIVERY') ||
            (this.props.subUseCase.id === 'AUTOMATED_DELIVERY' && this.props.secondSubUseCase.id === 'AUTOMATED_CONSOLIDATION')) {
            value = Math.min(firstValue, secondValue);
        } else if ((this.props.subUseCase.id === 'SHUTTLE_BUS_SERVICE' && this.props.secondSubUseCase.id === 'SHUTTLE_LARGE_SCALE') ||
            (this.props.subUseCase.id === 'SHUTTLE_LARGE_SCALE' && this.props.secondSubUseCase.id === 'SHUTTLE_BUS_SERVICE')) {
            // NA according to the excel
            value = 0;
        } else {
            value = 1 - ((1 - firstValue) + (1 - secondValue));
        }

        console.log('Value: ' + value);
        return value > 0 ? value : 0;
    }

    retrieveInterventions = () => {
        axios.get("/api/pst/interventions?subUseCase=" + this.props.subUseCase.id, {}).then(resp => {
            this.setState({interventions: resp.data});
        });
    }

    retrieveSecondInterventions = () => {
        axios.get("/api/pst/interventions?subUseCase=" + this.props.secondSubUseCase.id, {}).then(resp => {
            this.setState({secondInterventions: resp.data});
        });
    }


    back = () => {
        this.props.history.push('/pst');
    }

    onSelectImpact(event) {
        const impact = event.target.value ? parseInt(event.target.value) : null;
        this.setState({impact: impact});
        if (this.state.policyIntervention && this.state.secondPolicyIntervention && impact) {
            let firstMeasureValues = this.calculateChartValueForEachPolicy(this.state.policyIntervention, impact, this.state.policyYear, this.state.firstMeasure);
            let secondMeasureValues = this.calculateChartValueForEachPolicy(this.state.secondPolicyIntervention, impact, this.state.policyYear, this.state.secondMeasure);
            this.calculateChartTotal(firstMeasureValues, secondMeasureValues);
        } else {
            this.setState({data: null});
        }
    }

    onSelectPolicyIntervention(event) {
        let policyIntervention = event.target.value;
        this.setState({policyIntervention: policyIntervention});
        if (this.state.impact && policyIntervention && this.state.secondPolicyIntervention) {
            let firstMeasureValues = this.calculateChartValueForEachPolicy(this.state.policyIntervention, this.state.impact, this.state.policyYear, this.state.firstMeasure);
            let secondMeasureValues = this.calculateChartValueForEachPolicy(this.state.secondPolicyIntervention, this.state.impact, this.state.policyYear, this.state.secondMeasure);
            this.calculateChartTotal(firstMeasureValues, secondMeasureValues);
        } else {
            this.setState({data: null});
        }
    }

    onSelectSecondPolicyIntervention(event) {
        let secondPolicyIntervention = event.target.value;
        this.setState({secondPolicyIntervention: secondPolicyIntervention});
        if (this.state.impact && secondPolicyIntervention && this.state.policyIntervention) {
            let firstMeasureValues = this.calculateChartValueForEachPolicy(this.state.policyIntervention, this.state.impact, this.state.policyYear, this.state.firstMeasure);
            let secondMeasureValues = this.calculateChartValueForEachPolicy(this.state.secondPolicyIntervention, this.state.impact, this.state.policyYear, this.state.secondMeasure);
            this.calculateChartTotal(firstMeasureValues, secondMeasureValues);
        } else {
            this.setState({data: null});
        }
    }

    calculateChartValueForEachPolicy(policyIntervention, impact, policyYear, measure) {
        let initialValue;
        let values = [];
        let valuesWithout = [];
        let valuesWithoutMap = {};

        measure.withoutPolicyData.forEach((record) => {
            if (record.impact.id === impact) {
                for (const [key, value] of Object.entries(record.valuesMap)) {
                    if (key === '2020') {
                        initialValue = value;
                        valuesWithout.push(initialValue);
                        valuesWithoutMap[key] = initialValue;
                        continue;
                    }
                    let calcValue = value == null ? 0 : initialValue + initialValue * value;
                    valuesWithout.push(calcValue);
                    valuesWithoutMap[key] = calcValue;
                }
            }
        });

        let data;

        switch (policyIntervention) {
            case 'BASELINE':
                values = Array(31).fill(0);
                break;
            case 'CASE_1':
                data = measure.withPolicyDataCase1;
                break;
            case 'CASE_2':
                data = measure.withPolicyDataCase2;
                break;
            case 'CASE_3':
                data = measure.withPolicyDataCase3;
                break;
            case 'CASE_4':
                data = measure.withPolicyDataCase4;
                break;
            case 'CASE_5':
                data = measure.withPolicyDataCase5;
                break;
            case 'CASE_6':
                data = measure.withPolicyDataCase6;
                break;
            case 'CASE_7':
                data = measure.withPolicyDataCase7;
                break;
            case 'CASE_8':
                data = measure.withPolicyDataCase8;
                break;
            case 'CASE_9':
                data = measure.withPolicyDataCase9;
                break;
            case 'CASE_10':
                data = measure.withPolicyDataCase10;
                break;
            case 'CASE_11':
                data = measure.withPolicyDataCase11;
                break;
            case 'CASE_12':
                data = measure.withPolicyDataCase12;
                break;
            default:
                break;
        }

        values = this.onComputeWithPolicyValues(data, impact, policyYear, valuesWithoutMap, measure.policyParams);

        return {
            values: values,
            valuesWithout: valuesWithout
        };
    }


    calculateChartTotal(firstMeasure, secondMeasure) {
        let totalValuesWithout = [];
        let totalValues = [];
        let labels = [];

        var that = this;
        firstMeasure.values.forEach((first, index) => {
            let value = that.calculateFormula(first, secondMeasure.values[index]);
            totalValues.push(value);
        });

        firstMeasure.valuesWithout.forEach((first, index) => {
            let value = that.calculateFormula(first, secondMeasure.valuesWithout[index]);
            totalValuesWithout.push(value);
        });

        for (let i = 2020; i <= 2050; i++) {
            labels.push(i);
        }

        labels.sort();

        this.setState({
            data: {
                labels: labels,
                datasets: [
                    {
                        label: '# of Without Policy Intervention',
                        data: totalValuesWithout,
                        fill: false,
                        backgroundColor: 'rgba(218, 223, 225)',
                        borderColor: 'rgba(236, 236, 236)',
                        borderWidth: 4
                    },
                    {
                        label: '# of With Policy Intervention',
                        data: totalValues,
                        fill: false,
                        backgroundColor: 'rgb(165, 55, 253)',
                        borderColor: 'rgba(213, 184, 255)',
                        borderWidth: 4
                    },
                ],
            }
        });
    }

    onComputeWithPolicyValues(arr, impact, policyYear, valuesWithoutMap, policyParams) {
        let values = [];
        let initialValue;
        if (arr) {
            arr.filter((a) => a.impact.id === impact)
                .forEach((record) => {
                    for (const [key, value] of Object.entries(record.valuesMap)) {
                        let withoutImpactValue = valuesWithoutMap[key];
                        let policyEffectiveness = policyParams.filter((p) => p.type === 'POLICY_EFFECTIVENESS' && p.year === parseInt(key)).map((rec) => {
                            return rec.value;
                        });
                        let policyIntensity = policyParams.filter((p) => p.type === 'POLICY_INTENSITY' && p.year === parseInt(key)).map((rec) => {
                            return rec.value;
                        });

                        let impactValue;
                        let introductionLag = policyYear - 2020;
                        let targetYear = parseInt(key) - introductionLag;

                        if (key === '2020') {
                            initialValue = value;
                            impactValue = value;
                        } else {
                            if (parseInt(key) >= policyYear) {
                                let val = record.valuesMap[targetYear];
                                if (targetYear === 2020) {
                                    impactValue = val;
                                } else {
                                    impactValue = val == null ? 0 : initialValue + initialValue * val;
                                }
                            }
                        }

                        let calcValue;
                        if (parseInt(key) < policyYear) {
                            calcValue = withoutImpactValue;
                        } else {
                            calcValue = (withoutImpactValue * (1 - policyEffectiveness[0])) + (policyIntensity[0] * policyEffectiveness[0] * impactValue);
                        }

                        values.push(calcValue);
                    }
                });
        }

        return values;
    }

    onSelectPolicyYear(event) {
        let policyYear = event.target.value;
        this.setState({policyYear: policyYear});
        if (this.state.policyIntervention && this.state.secondPolicyIntervention && this.state.impact) {
            let firstMeasureValues = this.calculateChartValueForEachPolicy(this.state.policyIntervention, this.state.impact, this.state.policyYear, this.state.firstMeasure);
            let secondMeasureValues = this.calculateChartValueForEachPolicy(this.state.secondPolicyIntervention, this.state.impact, this.state.policyYear, this.state.secondMeasure);
            this.calculateChartTotal(firstMeasureValues, secondMeasureValues);
        } else {
            this.setState({data: null});
        }
    }

    retrieveHeaderSubtitle(scenario) {
        let title = '';

        switch (scenario) {
            case 'SCENARIO_1_NO_AUTOMATION':
                title += 'SCENARIO 1 - NO AUTOMATION';
                break;
            case 'SCENARIO_2_PESSIMISTIC':
                title += 'SCENARIO 2 - PESSIMISTIC';
                break;
            case 'SCENARIO_3_NEUTRAL':
                title += 'SCENARIO 3 - NEUTRAL';
                break;
            case 'SCENARIO_4_OPTIMISTIC':
                title += 'SCENARIO 4 - OPTIMISTIC';
                break;
        }

        return title;
    }

    retrieveHeaderTitle(useCase, subUseCase) {
        return subUseCase.description + ' vs ' + this.state.secondSubUseCase.description;
    }

    retrieveIntroductionLag() {
        return "Introduction lag: " + (this.state.policyYear - 2020);
    }

    calculatePolicyDataCase(record) {
        let result = {};
        for (const [key, value] of Object.entries(record.valuesMap)) {
            result[key] = key === '2020' ? value : value == null ? '-' : (value * 100).toFixed(2) + "%";
        }

        result.id = record.impact.id;
        result.impact = record.impact.impact;
        result.description = record.impact.description;
        result.measurementUnit = record.impact.measurementUnit;
        result.impactType = record.impact.impactType;

        return result;
    }


    render() {

        let withPolicyDataCase1Data = this.state.withPolicyDataCase1.map((record) => {
            return this.calculatePolicyDataCase(record);
        });

        let withPolicyDataCase2Data = {};
        let withPolicyDataCase3Data = {};
        let withPolicyDataCase4Data = {};
        let withPolicyDataCase5Data = {};
        let withPolicyDataCase6Data = {};
        let withPolicyDataCase7Data = {};
        let withPolicyDataCase8Data = {};
        let withPolicyDataCase9Data = {};
        let withPolicyDataCase10Data = {};
        let withPolicyDataCase11Data = {};
        let withPolicyDataCase12Data = {};
        let useCase2Exists = this.state.withPolicyDataCase2;
        let useCase3Exists = this.state.withPolicyDataCase3;
        let useCase4Exists = this.state.withPolicyDataCase4;
        let useCase5Exists = this.state.withPolicyDataCase5;
        let useCase6Exists = this.state.withPolicyDataCase6;
        let useCase7Exists = this.state.withPolicyDataCase7;
        let useCase8Exists = this.state.withPolicyDataCase8;
        let useCase9Exists = this.state.withPolicyDataCase9;
        let useCase10Exists = this.state.withPolicyDataCase10;
        let useCase11Exists = this.state.withPolicyDataCase11;
        let useCase12Exists = this.state.withPolicyDataCase12;

        if (useCase2Exists) {
            withPolicyDataCase2Data = this.state.withPolicyDataCase2.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
        }

        if (useCase3Exists) {
            withPolicyDataCase3Data = this.state.withPolicyDataCase3.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
        }

        if (useCase4Exists) {
            withPolicyDataCase4Data = this.state.withPolicyDataCase4.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
        }

        if (useCase5Exists) {
            withPolicyDataCase5Data = this.state.withPolicyDataCase5.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
        }

        if (useCase6Exists) {
            withPolicyDataCase6Data = this.state.withPolicyDataCase6.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
        }

        if (useCase7Exists) {
            withPolicyDataCase7Data = this.state.withPolicyDataCase7.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
        }

        if (useCase8Exists) {
            withPolicyDataCase8Data = this.state.withPolicyDataCase8.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
        }

        if (useCase9Exists) {
            withPolicyDataCase9Data = this.state.withPolicyDataCase9.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
        }

        if (useCase10Exists) {
            withPolicyDataCase10Data = this.state.withPolicyDataCase10.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
        }

        if (useCase11Exists) {
            withPolicyDataCase11Data = this.state.withPolicyDataCase11.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
        }

        if (useCase12Exists) {
            withPolicyDataCase12Data = this.state.withPolicyDataCase12.map((record) => {
                return this.calculatePolicyDataCase(record);
            });
        }

        let withoutPolicyDataData = this.state.withoutPolicyData.map((record) => {
            return this.calculatePolicyDataCase(record);
        });

        let renderUseCase2 = function (useCase2Exists, withPolicyDataCase2Data) {
            if (useCase2Exists) {
                return (<div className="row policy-result">
                    <h5>With Policy Intervention - Case 2</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={withPolicyDataCase2Data}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>)
            }
        }

        let renderUseCase3 = function (useCase3Exists, withPolicyDataCase3Data) {
            if (useCase3Exists) {
                return (<div className="row policy-result">
                    <h5>With Policy Intervention - Case 3</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={withPolicyDataCase3Data}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>)
            }
        }

        let renderUseCase4 = function (useCase4Exists, withPolicyDataCase4Data) {
            if (useCase4Exists) {
                return (<div className="row policy-result">
                    <h5>With Policy Intervention - Case 4</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={withPolicyDataCase4Data}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>)
            }
        }

        let renderUseRestCase = function (useCaseExists, number, withPolicyData) {
            if (useCaseExists) {
                return (<div className="row policy-result">
                    <h5>With Policy Intervention - Case {number}</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={withPolicyData}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>)
            }
        }

        return (
            <Container>
                <div className="row py-2">
                    <a href="" onClick={this.back} className="btn btn-outline-primary btn-sm">Back</a>
                </div>
                <div className="row result-header">
                    <h3>{this.retrieveHeaderTitle(this.props.useCase, this.props.subUseCase)}
                        <span> ({this.retrieveHeaderSubtitle(this.props.scenario)})</span>
                    </h3>

                </div>
                <Row>
                    <Col xs={12} md={3}>
                        <Form.Group controlId="useCase">
                            <Form.Label>Impact Selection</Form.Label>
                            <Form.Control
                                as="select"
                                onChange={this.onSelectImpact.bind(this)}>
                                <option value="">-- Please Select --</option>
                                <option value="1">Travel Time</option>
                                <option value="2">Vehicle operating cost</option>
                                <option value="3">Freight transport cost</option>
                                <option value="4">Access to travel</option>
                                <option value="5">Amount of travel</option>
                                <option value="6">Congestion</option>
                                <option value="7">Modal split of travel using public transport</option>
                                <option value="8">Modal split of travel using active travel</option>
                                <option value="9">Shared mobility rate</option>
                                <option value="10">Vehicle utilisation rate</option>
                                <option value="11">Vehicle occupancy</option>
                                <option value="12">Parking space</option>
                                <option value="14">Energy efficiency</option>
                                <option value="15">NOX due to vehicles</option>
                                <option value="16">CO2 due to vehicles</option>
                                <option value="17">PM10 due to vehicles</option>
                                <option value="18">Public health</option>
                                <option value="19">Accessibility in transport</option>
                                <option value="20">Commuting distances</option>
                                <option value="21">Unmotorized VRU crash rates</option>
                                <option value="22">Road safety motorized</option>
                                <option value="23">Road safety total effect</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xs={12} md={3}>
                        <Form.Group controlId="policyIntervention">
                            <Form.Label>First Policy Intervention (Cases)</Form.Label>
                            <Form.Control
                                as="select"
                                onChange={this.onSelectPolicyIntervention.bind(this)}>
                                <option value="">-- Please Select --</option>
                                {this.state.interventions.map((intervention) => (
                                    <option key={intervention.id}
                                            value={intervention.typeCase}>{intervention.description}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xs={12} md={3}>
                        <Form.Group controlId="policyIntervention">
                            <Form.Label>Second Policy Intervention (Cases)</Form.Label>
                            <Form.Control
                                as="select"
                                onChange={this.onSelectSecondPolicyIntervention.bind(this)}>
                                <option value="">-- Please Select --</option>
                                {this.state.secondInterventions.map((intervention) => (
                                    <option key={intervention.id}
                                            value={intervention.typeCase}>{intervention.description}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xs={12} md={3}>
                        <Form.Group controlId="policyYear">
                            <Form.Label>Policy Implementation Year</Form.Label>
                            <Form.Control type="number" placeholder="Policy Implementation Year" min="2020"
                                          max="2050"
                                          required
                                          aria-describedby="policyYear"
                                          defaultValue={this.state.policyYear}
                                          onChange={this.onSelectPolicyYear.bind(this)}/>
                            <Form.Text id="policyYear" muted>
                                {this.retrieveIntroductionLag()}
                            </Form.Text>
                        </Form.Group>
                    </Col>
                </Row>
                <div className="row">
                    <Line data={this.state.data} options={options}/>
                </div>
                <div className="row policy-result">
                    <h5>Without Policy Intervention</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={withoutPolicyDataData}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="row policy-result">
                    <h5>With Policy Intervention - Case 1</h5>
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={withPolicyDataCase1Data}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                {renderUseCase2(useCase2Exists, withPolicyDataCase2Data)}
                {renderUseCase3(useCase3Exists, withPolicyDataCase3Data)}
                {renderUseCase4(useCase4Exists, withPolicyDataCase4Data)}
                {renderUseRestCase(useCase5Exists, 5, withPolicyDataCase5Data)}
                {renderUseRestCase(useCase6Exists, 6, withPolicyDataCase6Data)}
                {renderUseRestCase(useCase7Exists, 7, withPolicyDataCase7Data)}
                {renderUseRestCase(useCase8Exists, 8, withPolicyDataCase8Data)}
                {renderUseRestCase(useCase9Exists, 9, withPolicyDataCase9Data)}
                {renderUseRestCase(useCase10Exists, 10, withPolicyDataCase10Data)}
                {renderUseRestCase(useCase11Exists, 11, withPolicyDataCase11Data)}
                {renderUseRestCase(useCase12Exists, 12, withPolicyDataCase12Data)}
            </Container>

        )
    }
}

export default SecondMeasureResult;
